var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.572,
    height: 51.243,
    viewBox: "0 0 53.572 51.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44419",
    "data-name": "Group 44419",
    transform: "translate(-6396.712 5044)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22160",
    "data-name": "Rectangle 22160",
    width: 17.785,
    height: 8,
    transform: "translate(6412.046 -5017.657)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26648",
    "data-name": "Path 26648",
    d: "M53.574,34.215V25.593l-3.485-.578a14.766,14.766,0,0,0-.728-1.766l2.05-2.871-6.095-6.1-2.871,2.05a15,15,0,0,0-1.766-.728l-.579-3.49H35.789v8.893a8.893,8.893,0,1,1,.188,17.785h-.188v8.893H40.1l.579-3.483a14.764,14.764,0,0,0,1.766-.728l2.871,2.05,6.095-6.1-2.05-2.871a15,15,0,0,0,.728-1.766Z",
    transform: "translate(6396.71 -5044)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22161",
    "data-name": "Rectangle 22161",
    width: 12.45,
    height: 12.45,
    transform: "translate(6417.382 -5032.774)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26649",
    "data-name": "Path 26649",
    d: "M45.569,31.406a9.189,9.189,0,0,0-2.025-5.753L42.283,26.7a7.511,7.511,0,0,1,1.656,4.7,7.409,7.409,0,0,1-6.52,7.4v-1.67a5.79,5.79,0,0,0,0-11.439v-1.67a7.286,7.286,0,0,1,3.825,1.628l1.034-1.279a8.91,8.91,0,0,0-4.859-2.014V11.227L29.6,3.3H16.144a4.065,4.065,0,0,0-7.986,0H2.369V51.242h35.05V40.456a9.051,9.051,0,0,0,8.151-9.05ZM30.083,6.126l4.553,4.617H30.083Zm10.6,25.28a4.126,4.126,0,0,1-3.26,4.049v-8.1a4.127,4.127,0,0,1,3.256,4.051ZM12.15,39.671A2.466,2.466,0,0,1,9.7,37.191V33.885H14.6v3.306a2.465,2.465,0,0,1-2.446,2.48M14.6,32.232H9.7V14.049H14.6ZM12.15,1.651A2.466,2.466,0,0,1,14.6,4.131V12.4H9.7V4.131a2.466,2.466,0,0,1,2.445-2.48M4,49.589V4.957H8.075V37.192a4.126,4.126,0,0,0,3.26,4.049v1.737h1.634V41.241a4.126,4.126,0,0,0,3.26-4.049V5.109a2.474,2.474,0,0,1,1.63,2.327v12.4a3.287,3.287,0,0,0,3.26,3.306V21.488a1.643,1.643,0,0,1-1.63-1.653V7.437a4.129,4.129,0,0,0-.836-2.48h9.8V12.4h7.336V49.589Z",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22162",
    "data-name": "Rectangle 22162",
    width: 1.778,
    height: 1.778,
    transform: "translate(6444.948 -5013.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22163",
    "data-name": "Rectangle 22163",
    width: 1.778,
    height: 1.778,
    transform: "translate(6440.673 -5021.35) rotate(-44.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22164",
    "data-name": "Rectangle 22164",
    width: 1.778,
    height: 1.778,
    transform: "translate(6440.673 -5003.878) rotate(-44.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26650",
    "data-name": "Path 26650",
    d: "M25.159,45.21l-1.266-5.7a2.057,2.057,0,0,0-3.96-.2l-2.007,6.018a.874.874,0,0,1-1.126.509.9.9,0,0,1-.149-.073l-1.6-1.069a3.455,3.455,0,0,0-4.252.421,2.719,2.719,0,0,1-1.91.791H5.926v1.778H8.885a4.443,4.443,0,0,0,3.168-1.313,1.637,1.637,0,0,1,2.009-.2l1.606,1.07a2.624,2.624,0,0,0,3.948-1.354l2.005-6.016a.289.289,0,0,1,.537.026l1.266,5.7a2.652,2.652,0,0,0,2.6,2.09h3.907V45.9H26.026a.88.88,0,0,1-.867-.7Z",
    transform: "translate(6396.71 -5044)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22165",
    "data-name": "Rectangle 22165",
    width: 1.778,
    height: 1.778,
    transform: "translate(6426.246 -4998.093)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22166",
    "data-name": "Rectangle 22166",
    width: 17.785,
    height: 1.778,
    transform: "translate(6414.166 -5016.796)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22167",
    "data-name": "Rectangle 22167",
    width: 17.785,
    height: 1.778,
    transform: "translate(6414.166 -5013.498)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22168",
    "data-name": "Rectangle 22168",
    width: 1.779,
    height: 1.779,
    transform: "translate(6414.703 -5010.2)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22169",
    "data-name": "Rectangle 22169",
    width: 14.228,
    height: 1.779,
    transform: "translate(6417.541 -5010.2)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22170",
    "data-name": "Rectangle 22170",
    width: 1.779,
    height: 1.779,
    transform: "translate(6441.392 -5032.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22171",
    "data-name": "Rectangle 22171",
    width: 1.778,
    height: 1.779,
    transform: "translate(6444.948 -5032.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22172",
    "data-name": "Rectangle 22172",
    width: 1.779,
    height: 1.779,
    transform: "translate(6448.505 -5032.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22173",
    "data-name": "Rectangle 22173",
    width: 1.779,
    height: 1.779,
    transform: "translate(6436.139 -4994.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22174",
    "data-name": "Rectangle 22174",
    width: 1.779,
    height: 1.779,
    transform: "translate(6439.437 -4994.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22175",
    "data-name": "Rectangle 22175",
    width: 1.779,
    height: 1.779,
    transform: "translate(6442.28 -4994.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26651",
    "data-name": "Path 26651",
    d: "M49.381,49.464a.8.8,0,0,0,.8-.8v-.8h.8a.8.8,0,0,0,0-1.609h-.8v-.8a.8.8,0,1,0-1.609,0v.8h-.8a.8.8,0,0,0,0,1.609h.8v.8a.8.8,0,0,0,.8.8h.009",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26652",
    "data-name": "Path 26652",
    d: "M0,10.784A2.024,2.024,0,1,0,2.026,8.76,2.024,2.024,0,0,0,0,10.784m2.7,0a.675.675,0,1,1-.675-.675.675.675,0,0,1,.675.675Z",
    transform: "translate(6396.71 -5044)",
    fill: "#ff7b00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductHover);
export default __webpack_public_path__ + "static/media/productHover.c83cc8135eb2f00bad99071809ba1bc2.svg";
export { ForwardRef as ReactComponent };